const REDUNDANT_RESPONSIBLE = 'natasha moreira'

function normalizeText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

function buildDuplicateKey(prazo) {
  const processNumber = normalizeText(prazo.numeroProcesso || prazo.processo).replace(/[^a-z0-9]/g, '')
  const task = normalizeText(prazo.descricao || prazo.titulo)
  return processNumber && task ? `${processNumber}|${task}` : null
}

function isNatashaMoreira(prazo) {
  return normalizeText(prazo.responsavel) === REDUNDANT_RESPONSIBLE
}

export function excludeRedundantNatashaPrazos(prazos) {
  const items = Array.isArray(prazos) ? prazos : []
  const keysWithAnotherResponsible = new Set(
    items
      .filter((prazo) => !isNatashaMoreira(prazo))
      .map(buildDuplicateKey)
      .filter(Boolean),
  )

  return items.filter((prazo) => {
    if (!prazo.atividadeId || !isNatashaMoreira(prazo)) return true
    const key = buildDuplicateKey(prazo)
    return !key || !keysWithAnotherResponsible.has(key)
  })
}
